export const locale = {
  lang: "it",
  data: {
    MENU: {
      SUPPORT_REQUEST: "Richiesta di supporto",
      OPEN_SUPPORT_REQUEST: "Apri richiesta di supporto",
      MY_SUPPORT_REQUEST: "Le mie richieste di supporto",
      SUPPORT_REQUEST_LIST: "Lista richieste di supporto",
      CATEGORIES_SUPPORT_REQUEST: "Categorie richieste di supporto",
      MANAGE_SUPPORT_REQUEST: "Gestione richieste di supporto",
    },
    ALERT: {
      SUCCESS_CREATE_SUPPORT_REQUEST: "Richiesta di supporto creata con successo.",
      ERROR_CREATE_SUPPORT_REQUEST: "Errore nella creazione della richiesta di supporto.",
      SUCCESS_REPLY_SUPPORT_REQUEST: "Risposta alla richiesta di supporto inviata con successo.",
      ERROR_REPLY_SUPPORT_REQUEST: "Errore nell'invio della risposta.",
    },
    TITLES: {
      SUPPORT: "Supporto",
    },
    STAFF_RESPONSE: "Risposta dello staff",
    DETAIL_SUPPORT_REQUEST: "Dettaglio richiesta di supporto",
    CLOSE_SUPPORT_REQUEST: "Rispondi e chiudi",
    NOT_ONE_SUPPORT_REQUEST: "Nessuna richiesta di supporto",
    LAST_UPDATE: "Ultimo aggiornamento",
  },
};
